import styles from "./InfoPage.module.scss";
import Nav from "@/components/Header/Nav/Nav";
import Footer from "@/components/Footer/Footer";
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";

const AgbCz = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Helmet>
        <title>
          VOP – HIXA – Oprava a servis DSG převodovek
        </title>
        <meta name="description" content="Všeobecné obchodní podmínky HIXA GmbH – oprava, výměna a náhradní díly DSG mechatroniky." />
      </Helmet>

      <Nav />
      <h2 className={` sectionContainer ${styles.title}`}>
        Všeobecné obchodní podmínky
      </h2>
      <div className="container sectionContainer sectionContainerWhite">
        <p className={styles.infoPageText}>
          Všeobecná ustanovení o prodeji nových a použitých automobilových dílů
        </p>
        <p className={styles.infoPageText}>
          Obchodní podmínky pro prodej náhradních dílů
        </p>

        <h2 className={styles.infoPageHeader}>I. Oblast působnosti</h2>
        <p className={styles.infoPageText}>
          1.1 Tyto Všeobecné obchodní podmínky (dále jen „VOP") společnosti HIXA
          s.r.o. (dále jen „Prodávající") se vztahují na všechny smlouvy o
          dodávce zboží, které spotřebitel nebo podnikatel (dále jen „Zákazník")
          uzavírá s Prodávajícím ohledně zboží nabízeného Prodávajícím v jeho
          internetovém obchodě. Začlenění vlastních obchodních podmínek
          Zákazníka se tímto vylučuje, pokud nebylo výslovně dohodnuto jinak.
        </p>
        <p className={styles.infoPageText}>
          1.2 Spotřebitelem ve smyslu těchto VOP je každá fyzická osoba, která
          uzavírá právní jednání za účelem, který nelze převážně přičíst její
          obchodní nebo samostatné výdělečné činnosti. Podnikatelem ve smyslu
          těchto VOP je fyzická nebo právnická osoba nebo právně způsobilé
          sdružení osob, které při uzavírání právního jednání jedná v rámci své
          obchodní nebo samostatné výdělečné činnosti.
        </p>

        <h2 className={styles.infoPageHeader}>II. Platební podmínky</h2>
        <p className={styles.infoPageText}>
          2.1 Kupní cena a ceny za případné doplňkové služby jsou splatné dle
          zvoleného způsobu platby, nejpozději před odesláním zboží, není-li
          výslovně sjednáno jinak (např. dobírka).
        </p>
        <p className={styles.infoPageText}>
          2.2 Zákazník je oprávněn započíst své pohledávky vůči pohledávkám
          Prodávajícího pouze tehdy, pokud jsou tyto pohledávky nesporné nebo
          byly pravomocně přiznány soudem. Výjimku tvoří pohledávky Zákazníka
          vyplývající ze stejné kupní smlouvy. Právo zadržení může Zákazník
          uplatnit pouze v rozsahu, v jakém se zakládá na nárocích ze stejného
          smluvního vztahu.
        </p>
        <p className={styles.infoPageText}>
          2.3 Pokud Zákazník neuhradí kupní cenu nebo ceny za doplňkové služby
          vůbec nebo v souladu se smlouvou, je Prodávající oprávněn od smlouvy
          odstoupit a/nebo v případě zaviněného porušení povinností Zákazníkem
          požadovat náhradu škody namísto plnění, pokud Prodávající marně
          stanovil Zákazníkovi přiměřenou lhůtu k plnění, ledaže stanovení lhůty
          není nutné vzhledem k povaze plnění.
        </p>
        <p className={styles.infoPageText}>
          2.4 Všechny ceny uvedené v internetovém obchodě obsahují zákonnou daň
          z přidané hodnoty (DPH).
        </p>
        <p className={styles.infoPageText}>
          2.5 Upozorňujeme, že při objednávkách ze Švýcarska nebo jiných zemí,
          které uplatňují dovozní cla, nemá společnost HIXA s.r.o. žádný vliv na
          výši celních poplatků nebo daní platných ve vaší zemi. Informujte se
          prosím předem o možných nákladech spojených s dovozem zboží do vaší
          země. Tyto poplatky vznikají až při dovozu, nejsou účtovány
          společností HIXA s.r.o. a nejsou zahrnuty v ceně dopravy.
        </p>
        <p className={styles.infoPageText}>
          Zákazník je oprávněn zvolit jeden z následujících způsobů úhrady kupní
          ceny: platba na fakturu, okamžitý online bankovní převod, platba na
          dobírku, PayPal nebo platba platební kartou.
        </p>

        <h2 className={styles.infoPageHeader}>III. Uzavření smlouvy</h2>
        <p className={styles.infoPageText}>
          3.1 Popisy a prezentace zboží uvedené v internetovém obchodě
          Prodávajícího nepředstavují závaznou nabídku ze strany Prodávajícího,
          ale pouze výzvu k podání nabídky; závaznou nabídku činí Zákazník
          odesláním objednávky.
        </p>
        <p className={styles.infoPageText}>
          3.2 Zákazník podává závaznou nabídku na uzavření kupní smlouvy
          prostřednictvím objednávkového formuláře integrovaného v internetovém
          obchodě, a to kliknutím na tlačítko dokončující objednávku po
          dokončení objednávkového procesu.
        </p>
        <p className={styles.infoPageText}>
          3.3 Prodávající může nabídku Zákazníka přijmout do pěti dnů:
        </p>
        <ul className={styles.infoPageList}>
          <li>
            zasláním písemného potvrzení objednávky nebo potvrzení v textové
            formě (např. e-mail, fax), přičemž rozhodující je doručení potvrzení
            Zákazníkovi, nebo
          </li>
          <li>
            dodáním objednaného zboží Zákazníkovi, přičemž rozhodující je
            doručení zboží, nebo
          </li>
          <li>
            zasláním výzvy k platbě, která výslovně potvrzuje přijetí objednávky.
          </li>
        </ul>
        <p className={styles.infoPageText}>
          Pokud nastane více uvedených skutečností, je smlouva uzavřena
          okamžikem, kdy nastane první z nich. Lhůta pro přijetí nabídky počíná
          běžet dnem následujícím po odeslání nabídky Zákazníkem a končí
          uplynutím pátého dne. Nebude-li nabídka Zákazníka ve lhůtě přijata,
          považuje se za odmítnutou a Zákazník již není svou nabídkou vázán.
        </p>
        <p className={styles.infoPageText}>
          3.4 Při zvolení způsobu platby PayPal je platba zpracována
          poskytovatelem platebních služeb PayPal (Europe) S.à r.l. et Cie,
          S.C.A., 22–24 Boulevard Royal, L-2449 Luxembourg (dále jen „PayPal").
          Platba se řídí podmínkami užívání PayPal, dostupnými v českém jazyce
          zde:{" "}
          <a href="https://www.paypalobjects.com/marketing/ua/pdf/CZ/cs/ua-103122.pdf">
            https://www.paypalobjects.com/marketing/ua/pdf/CZ/cs/ua-103122.pdf
          </a>
          , nebo – Nemá-li Zákazník účet PayPal, platba se řídí podmínkami pro
          platby bez účtu PayPal, dostupnými v českém jazyce zde:{" "}
          <a href="https://www.paypalobjects.com/marketing/ua/pdf/CZ/cs/privacy-full-100825.pdf">
            https://www.paypalobjects.com/marketing/ua/pdf/CZ/cs/privacy-full-100825.pdf
          </a>
          . Prodávající není smluvní stranou těchto podmínek a nemůže je měnit.
        </p>
        <p className={styles.infoPageText}>
          Zvolí-li Zákazník během online objednávky možnost „PayPal Express",
          dává kliknutím na tlačítko dokončující objednávku zároveň příkaz k
          provedení platby prostřednictvím PayPal. Smlouva je uzavřena v
          okamžiku, kdy PayPal potvrdí úspěšné provedení platby a Prodávající
          obdrží od PayPal potvrzení o úhradě.
        </p>
        <p className={styles.infoPageText}>
          3.5 Při podání nabídky prostřednictvím online objednávkového formuláře
          je text smlouvy uložen Prodávajícím a po odeslání objednávky je
          Zákazníkovi zaslán spolu s těmito VOP v textové podobě (např. e-mailem,
          faxem nebo dopisem). Text smlouvy je dále archivován na webových
          stránkách Prodávajícího v elektronické podobě a může být Zákazníkem
          bezplatně zpřístupněn prostřednictvím jeho heslem chráněného
          uživatelského účtu, pokud si Zákazník před odesláním objednávky takový
          účet zřídil.
        </p>
        <p className={styles.infoPageText}>
          3.6 Před závazným odesláním objednávky prostřednictvím online
          objednávkového formuláře má Zákazník možnost zkontrolovat správnost
          zadaných údajů pečlivým přečtením informací zobrazených na obrazovce.
          K lepšímu rozpoznání případných chyb může Zákazník využít i funkci
          zvětšení (zoom) v internetovém prohlížeči. Zákazník může své údaje v
          průběhu elektronického objednávkového procesu opravovat pomocí běžných
          funkcí klávesnice a myši až do okamžiku kliknutí na tlačítko
          dokončující objednávku.
        </p>
        <p className={styles.infoPageText}>
          3.7 Smlouva může být uzavřena v českém jazyce. V případě, že
          Prodávající poskytne i jiné jazykové verze smlouvy, mají tyto verze
          pouze informativní charakter. V případě rozporu mezi jazykovými
          verzemi má přednost české znění.
        </p>
        <p className={styles.infoPageText}>
          3.8 Zpracování objednávky a kontakt se Zákazníkem probíhá zpravidla
          prostřednictvím e-mailu a automatizovaného zpracování objednávek.
          Zákazník je povinen zajistit, aby e-mailová adresa uvedená v objednávce
          byla správná a aby zprávy zasílané Prodávajícím mohly být doručeny.
          Zejména při používání spamových filtrů musí Zákazník zajistit, aby
          všechny e-maily zasílané Prodávajícím nebo třetími osobami zapojenými
          do zpracování objednávky mohly být doručeny.
        </p>

        <h2 className={styles.infoPageHeader}>
          IV. Podmínky dodání a odeslání
        </h2>
        <p className={styles.infoPageText}>
          4.1 Dodání zboží probíhá odesláním na dodací adresu uvedenou
          Zákazníkem, pokud nebylo dohodnuto jinak.
        </p>
        <p className={styles.infoPageText}>
          4.2 Pokud přepravní společnost vrátí odeslané zboží Prodávajícímu z
          důvodu nemožnosti jeho doručení Zákazníkovi, nese Zákazník náklady na
          neúspěšné odeslání. To neplatí, pokud Zákazník účinně uplatnil své
          právo na odstoupení od smlouvy, pokud nenese odpovědnost za okolnosti,
          které vedly k nemožnosti doručení, nebo pokud mu bylo dočasně
          znemožněno převzetí zásilky, ledaže byl Prodávající povinen oznámit
          poskytnutí plnění v přiměřené lhůtě předem.
        </p>
        <p className={styles.infoPageText}>
          4.3 Jedná-li Zákazník jako podnikatel, přechází na něj nebezpečí
          náhodné ztráty a náhodného zhoršení prodané věci okamžikem, kdy
          Prodávající předá věc speditérovi, dopravci nebo jiné osobě či
          instituci pověřené provedením odeslání. Jedná-li Zákazník jako
          spotřebitel, přechází nebezpečí náhodné ztráty a náhodného zhoršení
          zpravidla až při převzetí zboží Zákazníkem nebo osobou jím pověřenou.
          Odchylně může nebezpečí přejít na spotřebitele již při předání zboží
          dopravci, pokud si Zákazník sám zvolil dopravce a Prodávající mu tuto
          osobu nebo instituci předem neurčil.
        </p>
        <p className={styles.infoPageText}>
          4.4 Prodávající si vyhrazuje právo odstoupit od smlouvy v případě
          nesprávného nebo nedostatečného vlastního zásobení. Toto právo je
          možné uplatnit pouze tehdy, pokud nedodání není způsobeno zaviněním
          Prodávajícího a pokud Prodávající s náležitou péčí uzavřel zajišťovací
          smlouvu se svým dodavatelem, pokud to bylo možné. Prodávající vynaloží
          veškeré přiměřené úsilí k zajištění dostupnosti zboží. V případě
          nedostupnosti nebo pouze částečné dostupnosti zboží bude Zákazník
          neprodleně informován a již poskytnuté protiplnění bude bezodkladně
          vráceno, nejpozději do 14 dnů.
        </p>
        <p className={styles.infoPageText}>
          4.5 Osobní odběr zboží není z logistických důvodů možný. Zboží je
          možné doručit pouze prostřednictvím přepravní služby.
        </p>

        <h2 className={styles.infoPageHeader}>V. Výhrada vlastnického práva</h2>
        <p className={styles.infoPageText}>
          5.1 Vůči spotřebitelům si Prodávající vyhrazuje vlastnické právo k
          dodanému zboží až do úplného zaplacení kupní ceny.
        </p>
        <p className={styles.infoPageText}>
          5.2 Vůči podnikatelům si Prodávající vyhrazuje vlastnické právo k
          dodanému zboží až do úplného uhrazení všech pohledávek Prodávajícího
          vůči Zákazníkovi vzniklých z obchodního vztahu.
        </p>
        <p className={styles.infoPageText}>
          5.3 Jedná-li Zákazník jako podnikatel, je oprávněn prodávat zboží
          zatížené výhradou vlastnického práva dále v rámci běžného obchodního
          styku. Veškeré pohledávky vůči třetím osobám vzniklé z dalším prodejem
          tohoto zboží postoupí Zákazník předem Prodávajícímu až do výše
          příslušné fakturované hodnoty (včetně DPH). Toto postoupení platí i v
          případě, že bylo zboží prodáno před nebo po jeho zpracování. Zákazník
          zůstává oprávněn tyto pohledávky inkasovat i po jejich postoupení.
          Právo Prodávajícího inkasovat pohledávky samostatně tím není dotčeno.
          Prodávající však pohledávky inkasovat nebude, dokud Zákazník řádně
          plní své platební povinnosti, není v prodlení a nebylo zahájeno
          insolvenční řízení.
        </p>

        <h2 className={styles.infoPageHeader}>
          VI. Odpovědnost za vady (zákonná odpovědnost za vady)
        </h2>
        <p className={styles.infoPageText}>
          Pokud je předmět koupě vadný, uplatní se zákonná ustanovení o
          odpovědnosti za vady. Odchylně se uplatní následující ustanovení:
        </p>
        <p className={styles.infoPageText}>
          <strong>6.1 Pro podnikatele</strong>
        </p>
        <p className={styles.infoPageText}>
          a) Nepodstatná vada zpravidla nezakládá právo odstoupit od smlouvy;
          podnikatel může požadovat zejména odstranění vady nebo přiměřenou
          slevu.
        </p>
        <p className={styles.infoPageText}>
          b) Není-li dohodnuto jinak, volba práva z vadného plnění náleží
          kupujícímu; Prodávající může navržený způsob odmítnout, je-li
          nepřiměřený.
        </p>
        <p className={styles.infoPageText}>
          c) Smluvní strany mohou ujednat zkrácení lhůt a/nebo omezení práv z
          vadného plnění v rozsahu dovoleném občanským zákoníkem; omezení se
          nevztahují na vady, které byly úmyslně zamlčeny.
        </p>
        <p className={styles.infoPageText}>
          <strong>6.2 Pro spotřebitele</strong>
        </p>
        <p className={styles.infoPageText}>
          Kupující (spotřebitel) je oprávněn uplatnit právo z vady, která se
          vyskytne u spotřebního zboží, ve lhůtě 24 měsíců od převzetí zboží. U
          použitého zboží lze tuto lhůtu po dohodě se spotřebitelem zkrátit
          nejméně na 12 měsíců. Takové zkrácení musí být výslovně uvedeno v
          potvrzení o koupi nebo na dokladu.
        </p>
        <p className={styles.infoPageText}>
          <strong>6.3 Výjimky</strong>
        </p>
        <p className={styles.infoPageText}>
          Výše uvedená omezení odpovědnosti a zkrácení promlčecích lhůt se
          nepoužijí:
        </p>
        <p className={styles.infoPageText}>
          a) na vady způsobené tím, že věc nebyla použita v souladu se svým
          obvyklým účelem;
        </p>
        <p className={styles.infoPageText}>
          b) na škody na životě, zdraví nebo těle způsobené úmyslným nebo
          nedbalým porušením povinností Prodávajícího, jeho zákonného zástupce
          nebo pomocníka;
        </p>
        <p className={styles.infoPageText}>
          c) na jiné škody způsobené úmyslným nebo hrubě nedbalým porušením
          povinností Prodávajícího;
        </p>
        <p className={styles.infoPageText}>
          d) v případech, kdy Prodávající vadu úmyslně zamlčel.
        </p>
        <p className={styles.infoPageText}>
          6.4 Pro podnikatele zůstávají nedotčena kogentní ustanovení občanského
          zákoníku upravující případné regresní nároky v dodavatelském řetězci.
        </p>
        <p className={styles.infoPageText}>
          6.5 Jedná-li Zákazník jako podnikatel, je povinen věc co nejdříve po
          převzetí prohlédnout a vady vytknout bez zbytečného odkladu poté, co je
          mohl zjistit při včasné prohlídce a při vynaložení řádné péče. Pokud
          vady nevyužije včas, může Prodávající uplatnit námitku opožděného
          vytknutí a soud mu právo z vadného plnění přiznat nemusí.
        </p>
        <p className={styles.infoPageText}>
          6.6 Je-li Zákazník spotřebitelem, doporučuje se při převzetí zboží
          zkontrolovat dodávku z hlediska zjevných poškození způsobených
          přepravou a případně tyto vady reklamovat u dopravce a informovat o
          nich Prodávajícího. Neučinění tohoto oznámení nemá vliv na zákonná ani
          smluvní práva Zákazníka z vad.
        </p>

        <h2 className={styles.infoPageHeader}>VII. Odpovědnost za vady věci</h2>
        <p className={styles.infoPageText}>
          7.1 Nároky kupujícího z vad věci se promlčují podle zákona ve lhůtě
          dvou let od převzetí předmětu koupě. Od tohoto pravidla se odchyluje
          promlčecí lhůta jeden rok, pokud je kupující právnickou osobou
          veřejného práva, osobou, která je správcem veřejného majetku, nebo
          podnikatelem, který jedná v rámci své podnikatelské činnosti při
          uzavírání smlouvy.
        </p>
        <p className={styles.infoPageText}>
          7.2 Zkrácení promlčecí lhůty uvedené v odst. 7.1 věta 2 se neuplatní
          na škodu způsobenou hrubou nedbalostí nebo úmyslným porušením
          povinností prodávajícím, jeho zákonným zástupcem nebo pomocníkem, ani
          v případě škody na životě, těle nebo zdraví.
        </p>
        <p className={styles.infoPageText}>
          7.3 Pokud má prodávající odpovídat za škodu způsobenou lehkou
          nedbalostí podle zákona, je odpovědnost prodávajícího omezena takto:
          odpovědnost vzniká pouze při porušení podstatných smluvních
          povinností, zejména takových, které smlouva ukládá prodávajícímu podle
          svého obsahu a účelu, nebo jejichž plnění umožňuje řádné plnění
          smlouvy a na která se kupující pravidelně spoléhá. Tato odpovědnost je
          omezena na typickou škodu, která byla při uzavírání smlouvy
          předvídatelná. Na výše uvedené omezení odpovědnosti a vyloučení se
          vztahuje odst. 7.2.
        </p>
        <p className={styles.infoPageText}>
          7.4 Práva kupujícího vyplývající z úmyslného zamlčení vady, z převzetí
          záruky za jakost nebo z převzetí rizika změny okolností zůstávají
          nedotčena bez ohledu na zavinění prodávajícího. Tím nejsou dotčeny ani
          nároky na náhradu škody způsobené vadou výrobku podle § 2939 až § 2943
          občanského zákoníku.
        </p>
        <p className={styles.infoPageText}>
          7.5 Pokud má být provedeno odstranění vady, platí následující
          ustanovení:
        </p>
        <p className={styles.infoPageText}>
          a) Nároky na odstranění vady může kupující uplatnit u prodávajícího
          nebo u servisních podniků, které jsou výrobcem/importérem uznány k
          servisování předmětu koupě. Pokud bylo první odstranění vady
          neúspěšné, musí kupující neprodleně informovat prodávajícího. Při
          ústním oznámení o nároku musí být kupujícímu vystaveno písemné
          potvrzení o doručení oznámení.
        </p>
        <p className={styles.infoPageText}>
          b) Pokud se předmět koupě stane nefunkční z důvodu materiální vady,
          může kupující kontaktovat nejbližší servisní podnik, který je
          výrobcem/importérem uznán k servisování předmětu.
        </p>
        <p className={styles.infoPageText}>
          c) Nároky z vad na díly instalované při odstranění vady může kupující
          uplatnit do uplynutí promlčecí lhůty pro předmět koupě.
        </p>
        <p className={styles.infoPageText}>
          d) Vyměněné díly se stávají vlastnictvím prodávajícího.
        </p>
        <p className={styles.infoPageText}>
          7.6 Převod vlastnictví k předmětu koupě nemá vliv na nároky z vad.
        </p>

        <h2 className={styles.infoPageHeader}>VIII. Soudní příslušnost</h2>
        <p className={styles.infoPageText}>
          <strong>8.1 Vztahy se spotřebiteli</strong>
        </p>
        <p className={styles.infoPageText}>
          Vztahy se spotřebiteli se řídí kogentními pravidly o příslušnosti
          soudů podle příslušných právních předpisů, zejména nařízení Evropského
          parlamentu a Rady (EU) č. 1215/2012 (Brusel I bis). Spotřebitel může
          podat žalobu u soudu podle svého místa bydliště nebo u soudu v místě
          plnění, pokud mu to poskytuje výhodnější ochranu; tímto ustanovením
          nejsou dotčena práva spotřebitele.
        </p>
        <p className={styles.infoPageText}>
          <strong>8.2 Vztahy s podnikateli</strong>
        </p>
        <p className={styles.infoPageText}>
          Pro spory mezi Prodávajícím a Zákazníkem, který jedná jako podnikatel,
          je místně příslušný soud podle sídla Prodávajícího, není-li kogentními
          právními předpisy stanoveno jinak.
        </p>
        <p className={styles.infoPageText}>
          <strong>8.3 ADR (ČOI)</strong>
        </p>
        <p className={styles.infoPageText}>
          Mimosoudní řešení spotřebitelských sporů (ADR) je možné u České
          obchodní inspekce (ČOI), Štěpánská 15, 120 00 Praha 2, e-mail:{" "}
          <a href="mailto:adr@coi.gov.cz">adr@coi.gov.cz</a>, web:{" "}
          <a href="https://coi.gov.cz/informace-o-adr/">
            coi.gov.cz/informace-o-adr/
          </a>
          . Spotřebitel může podat návrh na zahájení mimosoudního řešení sporu
          do 1 roku ode dne, kdy u Prodávajícího poprvé uplatnil své právo, které
          je předmětem sporu. Ustanovení o ADR se uplatní pouze tehdy, pokud se
          spor týká spotřebitelského vztahu a není vyloučen zákonem. ADR je
          mimosoudní a obvykle dobrovolné; podmínky a postup jsou upraveny
          zákonem o mimosoudním řešení spotřebitelských sporů.
        </p>

        <h2 className={styles.infoPageHeader}>IX. ZÁRUKA (GARANČNÍ OTÁZKY)</h2>
        <p className={styles.infoPageText}>
          9.1 Zákazník má (s výjimkou ustanovení pro podnikatele) zákonná práva
          z vadného plnění. U spotřebitelů se uplatní kogentní ustanovení
          občanského zákoníku a zákona o ochraně spotřebitele.
        </p>
        <p className={styles.infoPageText}>
          9.2 Záruka se nevztahuje na vady a škody vzniklé v důsledku:
        </p>
        <ul className={styles.infoPageList}>
          <li>nevhodného nebo nesprávného použití,</li>
          <li>nesprávného uvedení do provozu nebo montáže,</li>
          <li>běžného opotřebení,</li>
          <li>nedbalého nebo nesprávného zacházení,</li>
          <li>nedodržení návodu k údržbě nebo používání,</li>
          <li>
            nevhodných oprav nebo úprav provedených zákazníkem nebo třetími
            osobami.
          </li>
        </ul>
        <p className={styles.infoPageText}>
          <strong>9.3 Práva z vadného plnění pro podnikatele:</strong>
        </p>
        <p className={styles.infoPageText}>
          Pokud je zákazník podnikatelem ve smyslu § 14 občanského zákoníku,
          platí pro jeho reklamace následující ustanovení:
        </p>
        <p className={styles.infoPageText}>
          a) Dodatečné plnění: Má-li HIXA s.r.o. plnit z vadného plnění formou
          dodatečného plnění, volba mezi odstraněním vady nebo dodáním
          náhradního výrobku náleží HIXA s.r.o.
        </p>
        <p className={styles.infoPageText}>
          b) Oznámení vad: Zjevné vady musí být HIXA s.r.o. oznámeny bez
          zbytečného odkladu, nejpozději do 14 kalendářních dnů od doručení
          zboží, v textové formě (e-mail). Skryté vady musí být oznámeny bez
          zbytečného odkladu, nejpozději do 14 kalendářních dnů od jejich
          zjištění, e-mailem. Pokud oznámení o vadě nepřijde včas, Prodávající
          je oprávněn uplatnit námitku opožděného vytknutí vady; soud v takovém
          případě nemusí nároky z vadného plnění přiznat. Toto neplatí, pokud
          HIXA s.r.o. vadu úmyslně zatajila a/nebo převzala odpovídající záruku.
        </p>
        <p className={styles.infoPageText}>
          c) Promlčení: Nároky zákazníka z vadného plnění se promlčují během
          jednoho roku od předání předmětu koupě zákazníkovi, pokud zákon
          nestanoví pro konkrétní vadu delší promlčecí dobu nebo pokud vada
          vznikla úmyslně či z hrubé nedbalosti.
        </p>
        <p className={styles.infoPageText}>
          9.4 Na žádost zákonodárce vás informujeme o našich záručních
          podmínkách, které nemají vliv na zákonná ustanovení.
        </p>
        <p className={styles.infoPageText}>
          <strong>9.4.1 Obsah záruky:</strong> Tato dobrovolná záruka (garance)
          je poskytována nad rámec zákonných práv z vadného plnění a nijak je
          neomezuje. Zákonná práva zákazníka z vadného plnění podle občanského
          zákoníku zůstávají nedotčena. Záruka se vztahuje výhradně na práce
          provedené firmou HIXA s.r.o. (majitel Heorhii Shapovalov). U zaslaných
          demontovaných řídicích jednotek nejsou náklady na montáž součástí
          záruky a nemohou být hrazeny. Pokud byla příslušná řídicí jednotka
          namontována v našich prostorách pro zákazníka, vztahuje se záruka také
          na demontáž a montáž. Náklady na kontroly u externích firem se
          nehradí. Záruka na výměnná zařízení se vztahuje výhradně na
          moduly/komponenty uvedené ve faktuře. Záruka je omezena na vady
          uvedené v naší nabídce týkající se vozidla zákazníka. Zákazník je
          povinen před objednáním ověřit, zda objednaný díl odpovídá jeho
          vozidlu (model, rok výroby, číslo zařízení). Prodávající neodpovídá za
          vady nebo škody vzniklé v důsledku nesprávného výběru dílu zákazníkem.
        </p>
        <p className={styles.infoPageText}>
          <strong>9.4.2 Doba platnosti:</strong> Záruční doba začíná datem
          vystavení faktury a činí, v závislosti na poskytované službě, 1 rok
          pro neotevřená zařízení. Délka záruky je vždy uvedena v popisu
          zboží/služby. Neopravujeme řídicí jednotky ani jiné komponenty, pokud
          neodpovídají originálnímu stavu nebo byly otevřeny. Na výslovné přání
          zákazníka však v takových případech provádíme opravu podle nejlepšího
          vědomí a svědomí. K tomu je nutný souhlas objednatele. V takovém
          případě si vyhrazujeme právo omezit nebo vyloučit záruku na zařízení,
          jeho montáž a bezvadnou funkčnost. Toto omezení se nevztahuje na
          zákonná práva spotřebitele z vadného plnění.
        </p>
        <p className={styles.infoPageText}>
          <strong>9.4.3 Rozsah působnosti:</strong> Záruka platí v rámci ČR a EU
          a uplatňuje se u HIXA s.r.o., IČO: 24098655, sídlo: Nademlejnská
          600/1, Hloubětín, 198 00 Praha 9.
        </p>
        <p className={styles.infoPageText}>
          <strong>9.4.4 Záruční případ:</strong> Reklamace vady musí být podána
          písemně nebo ústně. Pro předběžné posouzení, zda se jedná o záruční
          případ, musí zákazník nechat příslušný díl znovu načíst a předat nám
          chybový kód spolu s kopií faktury. Po souhlasu s prověřením záručního
          případu může být zařízení zasláno k posouzení a záruční služba může
          být poskytnuta. Právo spotřebitele na odstoupení od smlouvy a podmínky
          jeho uplatnění se řídí výhradně článkem X těchto VOP.
        </p>
        <p className={styles.infoPageText}>
          9.4.5 Zákazník bere na vědomí, že při servisních úkonech (diagnostika,
          oprava, aktualizace softwaru) může dojít ke změnám nastavení zařízení
          nebo ke ztrátě dat. Zákazník je povinen si před předáním zařízení
          provést zálohu dat, pokud je to možné. Toto upozornění se nedotýká
          zákonných práv spotřebitele ani odpovědnosti prodávajícího za škodu
          způsobenou porušením právních povinností.
        </p>

        <h2 className={styles.infoPageHeader}>X. PRÁVO NA ODSTOUPENÍ</h2>
        <p className={styles.infoPageText}>
          <strong>
            10.1 Právo na odstoupení pro spotřebitele při dodání zboží:
          </strong>
        </p>
        <p className={styles.infoPageText}>
          Spotřebitel – jakákoli fyzická osoba, která uzavírá právní úkon za
          účelem, který převážně nesouvisí s její podnikatelskou nebo samostatně
          výdělečnou činností. Spotřebitel má právo odstoupit od této smlouvy do
          14 dnů bez udání důvodu.
        </p>
        <p className={styles.infoPageText}>Lhůta pro odstoupení činí 14 dnů od dne:</p>
        <ul className={styles.infoPageList}>
          <li>
            kdy spotřebitel nebo třetí osoba určená spotřebitelem, která není
            dopravcem, převzali zboží, pokud bylo objednáno jedno nebo více
            zboží v rámci jedné objednávky a je dodáváno společně;
          </li>
          <li>
            kdy spotřebitel nebo třetí osoba určená spotřebitelem, která není
            dopravcem, převzali poslední zboží, pokud bylo objednáno několik
            zboží v rámci jedné objednávky a jsou dodávána samostatně;
          </li>
          <li>
            kdy spotřebitel nebo třetí osoba určená spotřebitelem, která není
            dopravcem, převzali poslední částečnou zásilku nebo poslední část,
            pokud bylo zboží dodáváno ve více částečných zásilkách nebo částech.
          </li>
        </ul>
        <p className={styles.infoPageText}>
          Chcete-li uplatnit právo na odstoupení, musíte kontaktovat naši
          společnost HIXA s.r.o., IČO: 24098655, sídlo: Nademlejnská 600/1,
          Hloubětín, 198 00 Praha 9, telefon: +420292332384, e-mail:{" "}
          <a href="mailto:contact@czechia.hixa.eu">contact@czechia.hixa.eu</a>{" "}
          jasným prohlášením (např. dopisem, faxem nebo e-mailem) informovat o
          svém rozhodnutí odstoupit od této smlouvy. Můžete využít přiložený
          vzorový formulář pro odstoupení, ale není to povinné.
        </p>
        <p className={styles.infoPageText}>
          Pro dodržení lhůty pro odstoupení stačí, aby bylo oznámení o uplatnění
          práva na odstoupení odesláno před uplynutím lhůty.
        </p>
        <p className={styles.infoPageText}>
          <strong>
            10.2 Důsledky odstoupení pro spotřebitele při dodání zboží:
          </strong>
        </p>
        <p className={styles.infoPageText}>
          Pokud odstoupíte od této smlouvy, vrátíme vám všechny platby, které
          jsme od vás obdrželi, včetně nákladů na dodání odpovídajících
          nejlevnějšímu nabízenému způsobu dodání, bez zbytečného odkladu a
          nejpozději do 14 dnů ode dne, kdy jsme obdrželi oznámení o vašem
          odstoupení. K tomuto vrácení použijeme stejný způsob platby, jaký jste
          použili při původní transakci, pokud se nedohodneme jinak; v žádném
          případě vám nebudou účtovány poplatky za toto vrácení.
        </p>
        <p className={styles.infoPageText}>
          Můžeme si ponechat vrácení až do doby, než obdržíme zboží zpět, nebo
          dokud nám nepředložíte důkaz o odeslání zboží zpět, podle toho, co
          nastane dříve.
        </p>
        <p className={styles.infoPageText}>
          Musíte nám zboží vrátit nebo předat bez zbytečného odkladu a v každém
          případě nejpozději do 14 dnů ode dne, kdy jste nás informovali o
          odstoupení od této smlouvy. Lhůta je dodržena, pokud zboží odešlete
          před uplynutím 14denní lhůty.
        </p>
        <p className={styles.infoPageText}>
          Náklady na vrácení zboží nese zákazník.
        </p>
        <p className={styles.infoPageText}>
          Odpovídáte pouze za snížení hodnoty zboží, které vzniklo v důsledku
          nakládání se zbožím nad rámec běžného vyzkoušení jeho vlastností,
          charakteristik nebo funkčnosti.
        </p>
        <p className={styles.infoPageText}>
          <strong>
            10.3 Výjimky a důvody zániku práva na odstoupení pro spotřebitele
            při dodání zboží:
          </strong>
        </p>
        <p className={styles.infoPageText}>
          Právo na odstoupení nelze uplatnit u smluv o dodání zboží, které bylo
          vyrobeno podle specifikací spotřebitele nebo je jasně přizpůsobeno
          jeho osobním potřebám (např. zboží vyrobené na míru).
        </p>
        <p className={styles.infoPageText}>
          <strong>
            10.4 Právo na odstoupení pro spotřebitele při poskytování služeb:
          </strong>
        </p>
        <p className={styles.infoPageText}>
          Máte právo do 14 dnů bez udání důvodu odstoupit od této smlouvy. Lhůta
          pro odstoupení činí 14 dní ode dne uzavření smlouvy. Chcete-li
          uplatnit právo na odstoupení, musíte nás (HIXA s.r.o., IČO: 24098655,
          sídlo: Nademlejnská 600/1, 198 00 Praha 9 – Hloubětín, telefon:
          +420292332384, e-mail:{" "}
          <a href="mailto:contact@czechia.hixa.eu">contact@czechia.hixa.eu</a>)
          informovat jednoznačným prohlášením (např. dopisem, faxem nebo
          e-mailem) o svém rozhodnutí odstoupit od této smlouvy. Můžete využít
          přiložený vzorový formulář pro odstoupení, ale není to povinné. Pro
          dodržení lhůty pro odstoupení stačí, aby bylo oznámení o uplatnění
          práva na odstoupení odesláno před uplynutím lhůty.
        </p>
        <p className={styles.infoPageText}>
          <strong>
            10.5 Následky odstoupení pro spotřebitele při poskytování služeb:
          </strong>
        </p>
        <p className={styles.infoPageText}>
          Pokud odstoupíte od této smlouvy, vrátíme vám všechny platby, které
          jsme od vás obdrželi, včetně nákladů na doručení (kromě dodatečných
          nákladů vzniklých tím, že jste si zvolili jiný způsob doručení než
          nejlevnější standardní doručení, které nabízíme), bez zbytečného
          odkladu a nejpozději do 14 dnů ode dne, kdy jsme obdrželi oznámení o
          vašem odstoupení. K tomuto vrácení použijeme stejný způsob platby,
          jaký jste použili při původní transakci, pokud se nedohodneme jinak; v
          žádném případě vám nebudou účtovány poplatky za toto vrácení.
        </p>
        <p className={styles.infoPageText}>
          <strong>
            10.6 Výjimky a zánik práva na odstoupení pro spotřebitele při
            poskytování služeb:
          </strong>
        </p>
        <p className={styles.infoPageText}>
          Právo na odstoupení zaniká u smluv o poskytování služeb, pokud:
        </p>
        <ul className={styles.infoPageList}>
          <li>podnikatel plně poskytl službu,</li>
          <li>
            a zároveň začal s jejím plněním až poté, co spotřebitel dal výslovný
            souhlas,
          </li>
          <li>
            a současně spotřebitel potvrdil, že si je vědom zániku práva na
            odstoupení při plném poskytnutí služby.
          </li>
        </ul>
        <p className={styles.infoPageText}>
          <strong>10.7 Vzorový formulář pro odstoupení</strong>
        </p>
        <p className={styles.infoPageText}>
          (Pokud chcete od smlouvy odstoupit, vyplňte prosím tento vzor formuláře
          a pošlete jej zpět.)
        </p>
        <ul className={styles.infoPageList}>
          <li>
            Adresát: HIXA s.r.o., IČO: 24098655, sídlo: Nademlejnská 600/1, 198
            00 Praha 9 – Hloubětín
          </li>
          <li>
            Já / my (jméno, příjmení) oznamuji / oznamujeme, že tímto
            odstupuji/odstupujeme od smlouvy o nákupu tohoto zboží () / o
            poskytnutí těchto služeb ()
          </li>
          <li>Datum objednání () / datum obdržení ()</li>
          <li>Jméno a příjmení spotřebitele/spotřebitelů</li>
          <li>Adresa spotřebitele / spotřebitelů</li>
          <li>
            Podpis spotřebitele / spotřebitelů (pouze pokud je tento formulář
            zasílán v listinné podobě)
          </li>
          <li>Datum (*) Nehodící se škrtněte.</li>
        </ul>
        <p className={styles.infoPageText}>
          <strong>10.8 Vrácení peněz:</strong> Vrácení peněz se řídí platnými
          právními předpisy a povahou smlouvy. Vrácení peněz za zakázky na
          opravy, diagnostiku, programování a přenos dat se neposkytuje, pokud
          zákon nestanoví jinak. Tímto ustanovením nejsou dotčena zákonná práva
          spotřebitele, zejména právo na odstoupení od smlouvy uzavřené
          distančním způsobem nebo mimo obchodní prostory, pokud jsou splněny
          zákonné podmínky, ani práva z vadného plnění.
        </p>
        <p className={styles.infoPageText}>
          <strong>10.9 Stornování:</strong> Po přijetí zakázky na opravu HIXA
          s.r.o. zahájí opravu. Právo spotřebitele na odstoupení od smlouvy
          zaniká, pokud:
        </p>
        <ul className={styles.infoPageList}>
          <li>
            bylo započato s plněním služby na základě jeho výslovné žádosti, a
          </li>
          <li>
            spotřebitel byl předem poučen, že zahájením plnění zaniká právo na
            odstoupení.
          </li>
        </ul>
        <p className={styles.infoPageText}>
          <strong>10.10 Výjimky z práva na odstoupení:</strong> Právo na
          odstoupení od smlouvy podle občanského zákoníku nevzniká zejména u
          smluv:
        </p>
        <ul className={styles.infoPageList}>
          <li>
            o poskytování služeb, pokud byly v plném rozsahu splněny se souhlasem
            spotřebitele před uplynutím lhůty pro odstoupení a spotřebitel byl
            předem poučen o zániku tohoto práva,
          </li>
          <li>
            o dodávce zboží vyrobeného podle požadavků spotřebitele nebo
            přizpůsobeného jeho osobním potřebám,
          </li>
          <li>
            o opravě nebo úpravě věci, pokud bylo plnění zahájeno na základě
            výslovné žádosti spotřebitele před uplynutím lhůty pro odstoupení a
            spotřebitel byl předem poučen o zániku tohoto práva.
          </li>
        </ul>
        <p className={styles.infoPageText}>
          <strong>10.11 Storno poplatek</strong>
        </p>
        <p className={styles.infoPageText}>
          V případě, že zákazník zruší zakázku před zahájením plnění, je
          prodávající oprávněn požadovat přiměřenou náhradu odpovídající
          skutečně vynaloženým nákladům do okamžiku zrušení zakázky. Výše této
          náhrady musí odpovídat rozsahu již poskytnutého plnění a nesmí
          přesáhnout zákonem dovolenou míru.
        </p>

        <h2 className={styles.infoPageHeader}>XI. Závěrečná ustanovení</h2>
        <p className={styles.infoPageText}>
          Tato ustanovení jsou součástí všeobecných obchodních podmínek
          společnosti HIXA s.r.o. a jsou vykládána v souladu s právním řádem
          České republiky, zejména zákonem č. 89/2012 Sb., občanským zákoníkem,
          a zákonem č. 634/1992 Sb., o ochraně spotřebitele.
        </p>

      </div>
      <Footer></Footer>
    </div>
  );
};

export default AgbCz;
